import isMuiElement from '@mui/utils/isMuiElement';
export default isMuiElement;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/isMuiElement.js
// module id = 198
// module chunks = 25